import { Stack } from '@src/components';

import { AbsenceEditPanel } from './components';
import Timeline from './components/Timeline';

import { AbsencesTimelineProvider } from './context';

export default function AbsenceTimeline() {
  return (
    <AbsencesTimelineProvider>
      <Stack direction="row">
        <Timeline />
        <AbsenceEditPanel />
      </Stack>
    </AbsencesTimelineProvider>
  );
}
